import { Button, message, Popconfirm } from 'antd';
import React from 'react'

const DeleteVessel = (props) => {
    const confirm = (e) => {
        var token = document.getElementsByName("csrf-token")[0].content;
        fetch(`/admin/vessels/${props.vessel.id}.json`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": token
            },
            credentials: "same-origin",
        })
        .then(res => {
          window.location.assign('/admin/vessels')
        })
      message.success('Click on Yes');
    };
return (
  <Popconfirm
    title={`Delete Client ${props.vessel.name}`}
    description="Are you sure to delete this Vessel?"
    onConfirm={confirm}
    okText="Yes"
    cancelText="No"
  >
    <Button danger>Delete</Button>
  </Popconfirm>
);
}
export default DeleteVessel;